// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3FjLD","title":"styles_title__z39s_","topicList":"styles_topicList__UeTNq"};